import { render, staticRenderFns } from "./AddBoardSize.vue?vue&type=template&id=73d2d0d8&scoped=true"
import script from "./AddBoardSize.vue?vue&type=script&lang=js"
export * from "./AddBoardSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2d0d8",
  null
  
)

export default component.exports